export const env = new Proxy(process.env, {
  get(target, p, receiver) {
    if (p in target) return Reflect.get(target, p, receiver);

    throw new Error(`Environment variable ${p.toString()} is not set`);
  },
});

export const isProduction = () => process.env.NODE_ENV === `production`;

export const isServer = () => typeof window === `undefined`;
